import type { RemovableRef } from '@vueuse/core'
import { useTitrop, whenTitropReady } from '@/composables/useTitrop.ts'
import { useCircularBuffer } from '@/composables/useCircularBuffer.ts'
import { uniqBy } from 'lodash-es'

export interface EffortHistoryEntry {
  id: number
  type: string
  title: string
  docref?: string
}

let storage: RemovableRef<EffortHistoryEntry[]> | undefined = undefined
const buffer = useCircularBuffer<EffortHistoryEntry>(10)

whenTitropReady(() => {
  const titrop = useTitrop()
  storage = titrop.value.config.user('efforthistory', [])
  storage.value = uniqBy(storage.value, (e) => e.id)
  buffer.clear()
  buffer.push(...storage.value)
  let tooEarlyEntry!: EffortHistoryEntry | undefined
  while ((tooEarlyEntry = addedBeforeStorage.pop())) buffer.push(tooEarlyEntry)
})

const addedBeforeStorage: EffortHistoryEntry[] = []
export function useEffortHistoryService() {
  //
  // useTitropEvents().onLoginSuccess.once(() => {
  //   console.log(storage.value)
  // })
  //

  const push = (item: EffortHistoryEntry) => {
    if (!storage) {
      addedBeforeStorage.push(item)
      console.log('EffortHistoryService.push called too early')
      return
    }
    if (buffer.items.value.some((e) => e.id === item.id)) return
    buffer.push(item)
    if (storage) {
      storage.value = buffer.items.value
    }
  }

  const remove = (item: EffortHistoryEntry | number) => {
    if (typeof item == 'number') {
      const ef = buffer.items.value.find((e) => e.id === item)
      if (ef) remove(ef)
    } else {
      buffer.remove(item)
      if (storage) storage.value = buffer.items.value
    }
  }
  return {
    remove,
    push,
    items: buffer.items,
    clear: buffer.clear
  }
}
